import React, { useState } from 'react'
import SALink from 'components/SALink'
import {
  START_SELLING,
  WHO_CAN_SELL,
  WHAT_CAN_SELL,
  SHIPPING,
  PAYMENT,
  COMMISSION,
  ARTIST_HANDBOOK_LINK,
  ARTIST_NEWSLETTER_LINK,
} from '../../helpers/constants'
import StartSelling from './StartSelling'
import WhoCanSell from './WhoCanSell'
import WhatCanSell from './WhatCanSell'
import Shipping from './Shipping'
import Payment from './Payment'
import Commission from './Commission'
type State = {
  section: string
}

const Component = (): React.ReactElement<React.ComponentProps<any>, any> => {
  const [state, handleState] = useState({
    section: '',
  })
  const { section } = state

  const onToggle = (updateSection: string) => {
    const updateState = { ...state, section: section !== updateSection ? updateSection : '' }
    handleState(updateState)
  }

  return (
    <div data-type='faq'>
      <p data-type='title'>Frequently Asked Questions</p>
      <StartSelling section={START_SELLING} currentSection={section} onToggle={onToggle} />

      <WhoCanSell section={WHO_CAN_SELL} currentSection={section} onToggle={onToggle} />

      <WhatCanSell section={WHAT_CAN_SELL} currentSection={section} onToggle={onToggle} />
      <Shipping section={SHIPPING} currentSection={section} onToggle={onToggle} />
      <Payment section={PAYMENT} currentSection={section} onToggle={onToggle} />
      <Commission section={COMMISSION} currentSection={section} onToggle={onToggle} />
      <p data-type='more-info'>For more information, get started with these artist resources:</p>
      <div data-type='button-row'>
        <SALink
          data-type='button-link'
          target='_blank'
          rel='noopener noreferrer'
          href={ARTIST_HANDBOOK_LINK}
        >
          Artist Handbook
        </SALink>
        <SALink
          data-type='button-link'
          target='_blank'
          rel='noopener noreferrer'
          href={ARTIST_NEWSLETTER_LINK}
        >
          Artist Newsletter
        </SALink>
      </div>
    </div>
  )
}

export default Component